type AvatarProps = {
  src?: string;
  className?: string;
  alt?: string;
};

export function Avatar({
  src = '/kamibot-character/kamibot-portrait.png',
  className = '',
  alt = '카미봇',
}: AvatarProps) {
  return (
    <div className={`av ${className}`}>
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img src={src} alt={alt} />
    </div>
  );
}
